import { render, staticRenderFns } from "./DescriptionSelector.vue?vue&type=template&id=bb6c1eda&scoped=true"
import script from "./DescriptionSelector.vue?vue&type=script&lang=js"
export * from "./DescriptionSelector.vue?vue&type=script&lang=js"
import style0 from "./DescriptionSelector.vue?vue&type=style&index=0&id=bb6c1eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c1eda",
  null
  
)

export default component.exports